// extracted by mini-css-extract-plugin
export default {"spinner":"Spinner_spinner__H2HDD","rotate":"Spinner_rotate__eIvct"};